import { Formik } from 'formik';
import React, { useState } from 'react'
import Button from '../../../../../../components/form-control/Button';
import VehicleInformationForm from '../../../components/VehicleInformationForm';
import { SearchIcon } from 'lucide-react';
import Input from '../../../../../../components/form-control/Input';
import * as Yup from 'yup'
import { getFormattedPhoneNumber, getVehicleBodyTypeFromString, showToast } from '../../../../../../utils/miscFunctions';
import { Vehicle } from '../../../../../../models/vehicle/Vehicle';
import { addVehicleToPolicy, findVehicleBySearchParam } from '../../../../../../api/requests';
import { useQueryClient } from '@tanstack/react-query';

interface AddVehicleFormProps {
  policyId: string;
  closeModal: () => void;
}

  const AddVehicleForm = ({ policyId, closeModal }: AddVehicleFormProps) => {

    const [lookupPerformed, setLookupPerformed] = useState(false);
    const [lookUpValue, setLookUpValue] = useState('');
    const isLookupValueRegNum = lookUpValue && lookUpValue.length < 10;
    const queryClient = useQueryClient();

      const handleSubmit = async (values: any) => {
        if (values.powerType == 'hp') values.cc = Math.round(values.cc * 15);
    
        //setIsSubmitting(true)
        const payload: any = {
          maker: values.make,
          model: values.model,
          vehicleType: values.bodyType || null,
          color: values.color,
          chassisNumber: values.chassisNumber,
          cc: values.cc,
          yearIssued: values.manufacturedYear,
          registrationYear: values.registrationYear,
          registrationNumber: values.registrationNumber,
          maxSeat: values.maxSeat,
          vehicleRegion: values.vehicleRegion ? values.vehicleRegion : null,
          composerIsOwner:
            values.composerIsOwner === 'yes' ? true : values.composerIsOwner === 'no' ? false : false,
          natureOfInterest: values.natureOfInterestInVehicle
            ? values.natureOfInterestInVehicle
            : null,
          ownerName: values.ownerName ? values.ownerName : null,
          ownerPhone: values.ownerPhone ? getFormattedPhoneNumber(values.ownerPhone) : null,
          vehicleMainDriver: values.driver ? values.driver : null,
          installedAccessoriesValue: values.installedAccessoriesValue,
          vehicleAltered: values.vehicleAltered === 'yes' ? true : false,
          vehicleInGoodRepairState: values.vehicleInGoodRepairState === 'yes' ? true : false,
          driverHasComplications: values.driverHasComplications === 'yes' ? true : false,
          driverComplications: values.driverComplications ? values.driverComplications : null,
          alterationDetails: values.alterationDetails ? values.alterationDetails : null,
          repairState: values.repairState ? values.repairState : null,
          vehicleUsages: values.vehicleUsages ? values.vehicleUsages : null,
          issuedValue: values.sumInsured ? values.sumInsured  : 0,
    
        }
        try {
          const response = await addVehicleToPolicy(String(policyId), payload);
          if (response) {
            showToast.success(response?.message)
            closeModal();
            queryClient.invalidateQueries({ queryKey: ['fetchPolicy'] });
    
    
          }
        }
        catch (error: any) {
          showToast.error(error?.description)
          console.log(error)
        } finally {
          //setIsSubmitting(false)
        }
      }

    const handleFindVehicle = async (searchParam: string, setFieldValue: any) => {
      if (!searchParam?.trim()) return;
      const searchParamTrimmed = searchParam.replaceAll(/\s/g, "");

      //setIsFindingVehicle(true)
      try {
        let response = await findVehicleBySearchParam(searchParamTrimmed);

        if (response?.data) {
          //setVehicleLookUp(new Vehicle(response?.data));
          setLookupPerformed(true);
          showToast.success(response?.message,);
          const vehicleInstance = new Vehicle(response?.data);

          if (vehicleInstance.make) {
            setFieldValue('make', vehicleInstance.make);
            //setSelectedVehicleMake(vehicleInstance.make);
          }
          if (vehicleInstance.model) {
            setFieldValue('model', vehicleInstance.model);
          }
          if (vehicleInstance.yearIssued) {
            setFieldValue('manufacturedYear', vehicleInstance.yearIssued);
          }
          if (vehicleInstance.cc) {
            setFieldValue('cc', vehicleInstance.cc);
          }
          if (vehicleInstance.color) {
            setFieldValue('color', vehicleInstance.color);
          }
          if (vehicleInstance.registrationYear) {
            setFieldValue('registrationYear', (vehicleInstance.registrationYear));
          }
          if (vehicleInstance.maxSeat) {
            setFieldValue('maxSeat', (vehicleInstance.maxSeat));
          }
          if (vehicleInstance.insuredValue) {
            setFieldValue('sumInsured', (vehicleInstance.insuredValue));
          }
          if (vehicleInstance.chassisNumber) {
            setFieldValue('chassisNumber', vehicleInstance.chassisNumber);
          }
          if (vehicleInstance.registrationNumber) {
            setFieldValue('registrationNumber', vehicleInstance.registrationNumber);
          }
          if (vehicleInstance.type?.name) {
            setFieldValue('bodyType', getVehicleBodyTypeFromString(vehicleInstance.type.name));
          }
          if (vehicleInstance.state) {
            setFieldValue('state', vehicleInstance.state);
          }
          if (vehicleInstance.ownerName) {
            setFieldValue('owner', vehicleInstance.ownerName);
          } else {
            setFieldValue('owner', null);
          }
          if (vehicleInstance.ownerPhoneNumber) {
            setFieldValue('ownerPhone', vehicleInstance.ownerPhoneNumber);
          }
          if (vehicleInstance.ownerAddress) {
            setFieldValue('ownerAddress', vehicleInstance.ownerAddress);
          }
          if (vehicleInstance.driver?.phoneNumber) {
            setFieldValue('driverPhone', vehicleInstance.driver.phoneNumber);
          }
          if (vehicleInstance.driver?.email) {
            setFieldValue('driverEmail', vehicleInstance.driver.email);
          }
          if (vehicleInstance.driver?.license) {
            setFieldValue('driverLicense', vehicleInstance.driver.license);
          }
          if (vehicleInstance.driver?.hasDisease !== undefined) {
            setFieldValue('driverHasComplications', vehicleInstance.driver.hasDisease ? 'yes' : 'no');
          }
          if (vehicleInstance.driver?.diseaseOrComplications) {
            setFieldValue('driverComplications', vehicleInstance.driver.diseaseOrComplications);
          }
          if (vehicleInstance.vehicleAltered !== undefined) {
            setFieldValue('isVehicleAltered', vehicleInstance.vehicleAltered ? 'yes' : 'no');
          }
          if (vehicleInstance) {
            setFieldValue('driver', vehicleInstance.driver.fullName);
          }
          if (vehicleInstance.alterationDetails) {
            setFieldValue('alterationDetails', vehicleInstance.alterationDetails);
          }
          if (vehicleInstance.goodRepairState !== undefined) {
            setFieldValue('isInGoodRepairState', vehicleInstance.goodRepairState ? 'yes' : 'no');
          }
          if (vehicleInstance.repairState) {
            setFieldValue('repairState', vehicleInstance.repairState);
          }
          if (vehicleInstance.hasInstalledAccessories !== undefined) {
            setFieldValue('hasInstalledAccessories', vehicleInstance.hasInstalledAccessories ? 'yes' : 'no');
          }
          if (vehicleInstance.installedAccessoriesDetails) {
            setFieldValue('installedAccessoriesDetails', vehicleInstance.installedAccessoriesDetails);
          }
          if (vehicleInstance.installedAccessoriesValue) {
            setFieldValue('installedAccessoriesValue', vehicleInstance.installedAccessoriesValue);
          }
          if (vehicleInstance.hasInterestedParties !== undefined) {
            setFieldValue('hasInterestedParties', vehicleInstance.hasInterestedParties ? 'yes' : 'no');
            setFieldValue('thirdPartyInterested', vehicleInstance.hasInterestedParties ? 'yes' : 'no');
          }
          if (vehicleInstance.interestedParties) {
            setFieldValue('interestedParties', vehicleInstance.interestedParties);
          }
          if (vehicleInstance.natureOfInterest) {
            setFieldValue('natureOfInterest', vehicleInstance.natureOfInterest);
          }

        } else {
          showToast.success(response?.message,);
          setLookupPerformed(true);
          setFieldValue('make', '');
          setFieldValue('model', '');
          setFieldValue('manufacturedYear', '');
          setFieldValue('cc', '');
          setFieldValue('color', '');
          setFieldValue('registrationYear', '');
          setFieldValue('maxSeat', '');
          setFieldValue('sumInsured', '');
          setFieldValue('chassisNumber', '');
          setFieldValue('registrationNumber', '');
          setFieldValue('bodyType', '');
          setFieldValue('state', '');
          setFieldValue('owner', '');
          setFieldValue('ownerPhone', '');
          setFieldValue('ownerAddress', '');
          setFieldValue('driverPhone', '');
          setFieldValue('driverEmail', '');
          setFieldValue('driverLicense', '');
          setFieldValue('driverHasComplications', '');
          setFieldValue('driverComplications', '');
          setFieldValue('isVehicleAltered', '');
          setFieldValue('driver', '');
          setFieldValue('alterationDetails', '');
          setFieldValue('isInGoodRepairState', '');
          setFieldValue('repairState', '');
          setFieldValue('hasInstalledAccessories', '');
          setFieldValue('installedAccessoriesDetails', '');
          setFieldValue('installedAccessoriesValue', '');
          setFieldValue('hasInterestedParties', '');
          setFieldValue('thirdPartyInterested', '');
          setFieldValue('interestedParties', '');
          setFieldValue('natureOfInterest', '');


          if (isLookupValueRegNum) {
            setFieldValue('registrationNumber', searchParamTrimmed);
          } else {
            setFieldValue('chassisNumber', searchParamTrimmed);
          }

        }
      } catch (error: any) {
        showToast.error(error?.description,);
        console.log(error);
        setLookupPerformed(true);
        //setVehicleLookUp(null);

        if (isLookupValueRegNum) {
          setFieldValue('registrationNumber', searchParamTrimmed);
        } else {
          setFieldValue('chassisNumber', searchParamTrimmed);
        }
      } finally {

      }
    };

    return (
      <>
        <Formik
          initialValues={{
            make: '',
            model: '',
            color: '',
            powerType: '',
            registrationYear: '',
            manufacturedYear: '',
            sumInsured: '',
            cc: '',
            maxSeat: '',
            chassisNumber: '',
            registrationNumber: '',
            state: '',
            owner: '',
            ownerPhone: '',
            ownerAddress: '',
            driver: '',
            driverPhone: '',
            driverEmail: '',
            driverLicense: '',
            driverHasComplications: '',
            driverComplications: '',
            isVehicleAltered: '',
            alterationDetails: '',
            isInGoodRepairState: '',
            repairState: '',
            hasInstalledAccessories: '',
            installedAccessoriesDetails: '',
            installedAccessoriesValue: '',
            composerIsOwner: '',
            hasInterestedParties: '',
            interestedParties: '',
            natureOfInterest: '',
            thirdPartyInterested: '',
            ownerLossPayee: '',
            bodyType: '',
            vehicleUsages: '',
          }}
          validateOnChange={false}
          validateOnBlur={true}
          validationSchema={Yup.object({
            make: Yup.string().required('Vehicle make is required'),
            model: Yup.string().required('Vehicle model is required'),
            color: Yup.string().required('Color is required.'),
            cc: Yup.string().required('Cubic Capacity is required'),
            vehicleUsages: Yup.string().required('Vehicle usages is required'),
            bodyType: Yup.string().required('Vehicle body type is required').nullable(),
            maxSeat: Yup.string().required('Number of seats is required.'),
            manufacturedYear: Yup.string().required('Vehicle manufactured year is required.').nullable(),
            registrationYear: Yup.string().required('Vehicle registration year is required.'),
            registrationNumber: Yup.string()
              .required('Vehicle registration number is required.')
              .test(
                'registration-format-and-year-match',
                'Invalid registration number.',
                function (value) {
                  const { registrationYear } = this.parent;

                  if (!value) return true;

                  const registrationNumber = value.trim().toUpperCase();

                  const parts = registrationNumber.split('-');

                  // Must contain "-" and digits after it
                  if (parts.length < 2) {
                    return this.createError({
                      message:
                        'Registration number must contain "-" followed by digits (e.g. GS111-07).',
                    });
                  }

                  const suffix = parts[parts.length - 1]?.trim();

                  if (!/^[0-9]{1,2}$/.test(suffix)) {
                    return this.createError({
                      message:
                        'Registration number must end with "-" followed by 1 or 2 digits (e.g. GS111-07).',
                    });
                  }

                  // If year exists, check match
                  if (registrationYear) {
                    const lastTwoDigitsOfYear = registrationYear.slice(-2);
                    const normalizedSuffix = suffix.padStart(2, '0');

                    if (normalizedSuffix !== lastTwoDigitsOfYear) {
                      return this.createError({
                        message: `Registration number suffix (-${suffix}) must match registration year (${registrationYear}). Example: GS111-${lastTwoDigitsOfYear}.`,
                      });
                    }
                  }

                  return true;
                }
              ),
            sumInsured: Yup.number().required(),
            chassisNumber: Yup.string()
              .required('Vin is required.'),
            // .min(17, 'Vin must be 17 characters long')
            // .max(17, 'Vin must be 17 characters long'),
            hasInterestedParties: Yup.string()
              .nullable()
              .when(['natureOfInterest', 'composerIsOwner'], {
                is: (natureOfInterest: string, composerIsOwner: string) => {
                  return natureOfInterest !== 'New owner, yet to change at DVLA' &&
                    natureOfInterest !== 'New owner, yet to change at FRSC' &&
                    composerIsOwner == 'no';
                },
                then: (schema) => schema.required('Interest in vehicle required.'),
                otherwise: (schema) => schema.notRequired(),
              }),
          })}
          onSubmit={(values) => {
            handleSubmit(values)
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => {
            return (
              <form id="single-vehicle-form" className="space-y-10 px-6" onSubmit={handleSubmit}>

                <div className='flex flex-col sm:flex-row w-full items-start sm:items-end justify-center gap-4 mb-6'>
                  <Input
                    label="Vehicle Registration OR Chassis Number / VIN"
                    placeholder="Enter Vehicle Registration OR Chassis Number / VIN"
                    name="lookUpValue"
                    onChange={(e) => setLookUpValue(e.target.value.toUpperCase())}
                    value={lookUpValue}
                    labelClasses="!text-gray-700 dark:!text-gray-300"
                  />
                  <Button
                    disabled={!lookUpValue}
                    onClick={() => { lookUpValue && handleFindVehicle(lookUpValue, setFieldValue) }}
                    label="Find Vehicle"
                    bgColor={lookUpValue ? "primary" : "secondary"}
                    icon={<SearchIcon className="h-4 w-4" />}
                  />

                </div>

                {lookupPerformed && (
                  <>
                    <VehicleInformationForm showVehicleUsages />


                    <div className="flex justify-between gap-4 pt-4 pb-4">
                      <Button
                        type="button"
                        label="Cancel"
                        bgColor="secondary"
                        fullWidth
                        onClick={closeModal}
                      //disabled={isSubmitting}
                      />
                      <Button
                        type="submit"
                        label={'Add Vehicle'}
                        bgColor="primary"
                        fullWidth
                      //loading={isSubmitting}
                      //disabled={isSubmitting}
                      />
                    </div>
                  </>)}
              </form>
            )
          }}
        </Formik>
      </>
    )
  };

export default AddVehicleForm